import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { GetCMSDataService, StartQuoteService, UtilService, SERVICE_END_POINT, QuoteDataCaptureService, AnalyticsService, CURRENT_ENVIROMENT } from '../../../../shared';
import * as UserDataConfig from '../../config/user-data.config';
import * as BreadcrumbDataConfig from '../../../../common-components/config/user-data.config';

// import { Store } from '@ngrx/store';
// import { AppState } from '../../../../store/state/app.state';
// import { RefNo } from '../../../../model/ngrx/reference-number.model';
// import * as RefNoActions from '../../../../store/actions/reference-number.actions';
// import * as BeforeYouStartActions from '../../../../store/actions/before-start.actions';
// import * as DependantDetailsActions from '../../../../store/actions/dependant-details.actions';
// import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
// import * as QuotePlaybackRiskWarningActions from '../../../../store/actions/playback-risk-warnings.actions';
// import * as ProductChoiceActions from '../../../../store/actions/product-choice.actions';
// import * as quoteResultActions from '../../../../store/actions/quote-result.actions';
// import * as ReqQuoteCalculationActions from '../../../../store/actions/request-quote-calculation.actions';
// import * as ResQuoteCalculationActions from '../../../../store/actions/response-quote-calculation.actions';
// import * as ResQuoteDatacaptureActions from '../../../../store/actions/response-quote-datacapture.actions';
// import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
// import * as LifeStyleActions from '../../../medical-underwriting/store/actions/lifestyle.action';


import { Observable } from 'rxjs';
import { Logout } from 'src/app/store/actions/logout.actions';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})


export class ListUserComponent implements OnInit, OnDestroy {
  // userData: any;
  // public userInputDetail = UserDataConfig.ElementsConfig;
  // userForm: FormGroup;
  // contentData;
  // enableBackNav=true;
  // public CMSData;
  // cameFromMicrosite = false;
  // private screenName;
  // private displayAlert = false;
  // serverDetail;
  // isloading: boolean = false;

  constructor(
    // private messageService: GetCMSDataService, private fb: FormBuilder, private router: Router,
    //           private startQuoteService: StartQuoteService, private store: Store<AppState>,
    //           private activatedRoute: ActivatedRoute,
    //           private utilService: UtilService,
    //           private quoteDatacaptureService: QuoteDataCaptureService,
    //           private analyticsService: AnalyticsService
              ) {
      // this.contentData = this.activatedRoute.snapshot.data.contentData.youWillNeed;
      // this.serverDetail = BreadcrumbDataConfig.BreadcrumbConfig.authServer;
  }

  ngOnInit() {
  //   this.GetCMSDataService();
  //   if(this.activatedRoute.snapshot.queryParamMap.has('dealPartner')) {
  //     this.enableBackNav = false;
  //     this.cameFromMicrosite = true;
  //   } else {
  //     this.enableBackNav = true;

  //   }
  //   // this.activatedRoute.snapshot.queryParamMap.has('dealPartner') ? this.enableBackNav = false : this.enableBackNav=true;
  //   this.userFormData();
  //   // this.startQuoteService.setRefNo('');
  //   this.messageService.userDetail.subscribe(response => this.userData = response);
   }


  // userFormData = () => {
  //   this.userForm = this.fb.group({
  //     next: ['']
  //   });
  // }


  // goBack = (userForm: any) => {
  //   this.messageService.sendUserData({ data: userForm ? userForm.value : null, index: 0 });
  //   // this.cmsService.sendUserData(userForm.value);
  //   this.router.navigate(['/home/create']);
  // }




  ngOnDestroy() {
  //   // unsubscribe to ensure no memory leaks
  //    // this.subscription.unsubscribe();
  // }
  /** Code block for CMS */
  // GetCMSDataService() {
  //   const URL = SERVICE_END_POINT.higherEnvironment.CMS_ToGetAQuoteYouWillNeed;
  //   this.utilService.getCMSData(URL).subscribe(res => {
  //     this.CMSData = res;
  //     if (this.CMSData) {
  //     /** In the line below we are over-writing the contentData object values with CMSData object values */
  //     this.contentData.header = this.CMSData.string_ToGetAQuoteYouWillNeedTitle;
  //     this.contentData.paraText1 = this.CMSData.string_PensionsSavingsDetails;
  //     this.contentData.paraText2 = this.CMSData.html_MedicalDetailsWording;
  //     this.userInputDetail.buttonConfig.label = this.CMSData.string_StartCTALabel;
  //   }
  //   });
  }
  /** End of code block for CMS */


}


